import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ModalState, ModalSettingsConfirm } from './generic-modal.service';

@Component({
    selector: 'ep-modal-confirm',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './modal-confirm.component.html'
})
export class ModalConfirmComponent {
    options: ModalSettingsConfirm;

    constructor(private modalState: ModalState) {
        this.options = modalState.options as ModalSettingsConfirm;
    }

    close() {
        this.modalState.modal.dismiss();
    }

    ok() {
        this.modalState.modal.close();
    }
}